import { useSpacePath } from '../../../../hooks/useSpacePath';
import { useGetExistingMatchRecord } from '../../api/useGetExistingMatchRecord';
import type { ExistingMatch } from '../../types/inbox.types';
import { buildExistingMatchPreview } from '../../utils/existingMatchPreview';

type Props = {
  match: ExistingMatch;
};

export function useExistingMatchPreview(props: Props) {
  const spacePath = useSpacePath();
  const { data: record, isPending, isError } = useGetExistingMatchRecord({ match: props.match });

  // A failed read keeps the saved label rather than claiming the record is gone.
  const preview = buildExistingMatchPreview(props.match, isError ? undefined : record);
  const reason = props.match.reason?.trim() || null;

  return {
    preview,
    isLoading: isPending,
    note: preview.missingNotice ?? reason,
    isAiNote: !preview.missingNotice && props.match.source === 'ai' && Boolean(reason),
    href: preview.link ? spacePath(preview.link.path) : null,
  };
}
